export default __webpack_public_path__ + "static/media/identity.f58a1372.jpg";